import m from "../../../../geodata/es2015/region/usa/nmLow";
window.am4geodata_region_usa_nmLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/nmLow.js
// module id = null
// module chunks = 